module.exports = __webpack_public_path__ + "static/img/pic_10@2x.fe30a0dd.png";